// eslint-disable-next-line react/no-deprecated
import { render } from 'react-dom';

import 'raf/polyfill';
import '../config/polyfills';

import App from './App';
import configureStore from './app/store';
import { watchOnlineState } from './offline/actions';

const appRoot = document.getElementById('app-host');
const store = configureStore();

// Track browser's online state
watchOnlineState(store);

/* To mock any entity's endpoints during local development:
  - uncomment below code and import a worker from the entity's mswMocks
  - run `npx msw init public/ --save` in terminal
  - you'll know the mocks are set up when you see '[MSW] Mocking enabled.' in browser console
  - you can see which endpoints that are called have/haven't been mocked in browser console
*/
// if (import.meta.env.MODE === 'dev') {
//   worker.start();
// }

render(<App store={store} />, appRoot);
